import type { SortKey } from "@/utils/content";

interface SortBarProps {
  sortKey: SortKey;
  onChange: (key: SortKey) => void;
  onOpenFilter?: () => void;
  resultText?: string;
}

const sortOptions: { key: SortKey; label: string; icon: string }[] = [
  { key: "updated", label: "按更新时间", icon: "ri-time-line" },
  { key: "rating", label: "按评分", icon: "ri-star-line" },
  { key: "popularity", label: "按人气", icon: "ri-fire-line" }
];

export default function SortBar({
  sortKey,
  onChange,
  onOpenFilter,
  resultText
}: SortBarProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 rounded-lg border border-background-800 bg-background-900/70 p-3 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-sm text-foreground-400">
        {resultText || "共找到相关内容"}
      </p>
      <div className="flex items-center gap-2">
        {onOpenFilter && (
          <button
            type="button"
            onClick={onOpenFilter}
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-700 px-3 py-1.5 text-sm text-foreground-200 transition-colors hover:border-secondary-500 hover:text-secondary-300 lg:hidden"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-filter-3-line" aria-hidden="true" />
            </span>
            筛选
          </button>
        )}
        <div className="flex flex-wrap items-center gap-1 rounded-md border border-background-700 bg-background-950/60 p-1">
          {sortOptions.map((option) => {
            const active = sortKey === option.key;
            return (
              <button
                key={option.key}
                type="button"
                onClick={() => onChange(option.key)}
                className={`flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-500 transition-colors ${
                  active
                    ? "bg-accent-500 text-background-950"
                    : "text-foreground-300 hover:text-accent-400"
                }`}
              >
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className={option.icon} aria-hidden="true" />
                </span>
                {option.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}